import { DatePipe, NgClass } from '@angular/common';
import { Component, computed, inject, input, LOCALE_ID, OnInit, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { RouterLink } from '@angular/router';
import { BundleService } from '../../../../../../services/bundle/bundle';
import { Loading } from '../../../../../../utils/loading/loading';
import { ErrorData } from '../../../../../../utils/error-data/error-data';
import {
  BundleProduct,
  BundleProductsPricing,
  BundleProductsResponse,
} from '../../../../../../pages/admin-dashboard/promotions/bundles-managment/bundles.model';

@Component({
  selector: 'app-bundle-included-items-tab',
  imports: [DatePipe, RouterLink, Loading, ErrorData],
  templateUrl: './bundle-included-items-tab.html',
  styleUrl: './bundle-included-items-tab.scss',
})
export class BundleIncludedItemsTab implements OnInit {
  private bundleService = inject(BundleService);
  private locale = inject(LOCALE_ID);

  bundleId = input.required<string>();
  products = signal<BundleProduct[]>([]);
  bundleProductsData = signal<BundleProductsPricing | null>(null);

  isArabic = computed(() => this.locale.startsWith('ar'));

  loading = signal(false);
  error = signal<string | null>(null);

  ngOnInit() {
    this.loadProducts();
  }

  loadProducts() {
    this.loading.set(true);
    this.bundleService
      .getBundleProducts(this.bundleId())
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: (res) => {
          this.products.set(res.products);
          this.bundleProductsData.set(res.pricing);
        },
        error: (err) => {
          this.error.set(this.isArabic() ? err.messageAr || 'حدث خطأ ما' : err.messageEn || 'Failed to load products.');
        },
      });
  }
}
